import YaCounter from "../ym";

window.VegasCatalog.Cart = {
	add: function (id, cnt, params, callback) {
		params = params || {};
		params.id = id;
		params.cnt = cnt || 1;
		params._token = App.csrf;

		this.addRequest(params, callback);
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
			VegasCatalog.popup('Добавлено в корзину');

			new YaCounter().goal('add-to-cart');
		});
	},

	changeCnt: function (id, cnt, appendParams, callback) {
		let params = appendParams || {};
		params.id = id;
		params.cnt = cnt;
		params = VegasCatalog.Cart.formData(params);

		$.post('/cart/change_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
		});
	},

	remove: function (id, callback) {
		let params = {};
		params.id = id;
		params._token = App.csrf;

		this.removeRequest(params, callback);
	},

	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
			VegasCatalog.popup('Убрано из корзины');
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			let $cartTool = $('[data-cart][data-counter=products]');

			$cartTool.attr('data-cnt', data.products_count);
			$cartTool.addClass('active');

			setTimeout(() => {
				$cartTool.removeClass('active');
			}, 1000);
		}

		this.totalCartForm(data);
		this.totalCartProducts(data);
	},

	totalCartForm: function (data) {
		let $form = $('#form-cart');

		if ($form.length) {
			// products sum
			let $sProducts = $form.find('[data-sum="products"]');
			$sProducts.find('[data-sum-value]').text(output_roubles(data.sums.sum_products));

			// cart sum
			let $sCart = $form.find('[data-sum="total"]');
			$sCart.find('[data-sum-value]').text(output_roubles(data.sums.sum));

			// delivery sym
			let $sDelivery = $form.find('[data-sum="delivery"]');
			if (data.sums.sum_delivery !== null) {
				$sDelivery.find('[data-sum-value]')
					.text(
						isNaN(data.sums.sum_delivery) ? data.sums.sum_delivery : (
							data.sums.sum_delivery > 0 ? output_roubles(data.sums.sum_delivery) : 'бесплатно'
						)
					);
				$sDelivery.show();
			} else {
				$sDelivery.hide();
			}
		}
	},

	totalCartProducts: function (data) {
		let $cartProducts = $('.catalog-cart--products');
		if ($cartProducts.length && typeof data.products_totals !== 'undefined') {
			for (let i in data.products_totals) {
				let p = data.products_totals[i];

				$cartProducts.find('[data-product-cart-item][data-pivot_id="' + p.pivot_id + '"]')
					.find('.price-total')
					.text(output_roubles(p.price_total));
			}
		}
	},

	updateTotalAll: function () {
		$.get('/cart/get_totals', VegasCatalog.Cart.formData(), function (data) {
			VegasCatalog.Cart.total(data);
		});
	},

	formData: function (appendParams) {
		appendParams = appendParams || {};
		let resultParams = $('#form-cart').serializeArray();

		if (!resultParams.length) {
			resultParams.push({name: '_token', value: App.csrf});
		}

		for (let name in appendParams) {
			resultParams.push({name: name, value: appendParams[name]});
		}

		return resultParams;
	},
};

let $document = $(document),
	$formCart = $("#form-cart")
;

/** PRODUCT LIST **/
$document.on('click', '[data-product-item] [data-cart][data-action=add]', function () {
	let $product = $(this).closest('[data-product-item]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.addClass('in-cart');
	$btn.attr('data-action', 'del');

	VegasCatalog.Cart.add(id);

	return false;
});
$document.on('click', '[data-product-item] [data-cart][data-action=del]', function () {
	let $product = $(this).closest('[data-product-item]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.removeClass('in-cart');
	$btn.attr('data-action', 'add');

	VegasCatalog.Cart.remove(id);

	return false;
});

/** PRODUCT SHOW **/
$document.on('click', '[data-product] [data-cart][data-action=add]', function () {
	let $product = $(this).closest('[data-product]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.addClass('in-cart');

	VegasCatalog.Cart.add(id);

	return false;
});
$document.on('click', '[data-product] [data-cart][data-action=del]', function () {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');

	$product.removeClass('in-cart');

	VegasCatalog.Cart.remove(id);

	return false;
});
$document.on('change-counter', '[data-product] [data-cart="qty"]', function () {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');

	let cnt = $(this).find('input[type=number]').val();
	VegasCatalog.Cart.changeCnt(id, cnt);

	return false;
});
$document.on('click', '[data-product] [data-qty=trash]', function () {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');

	$product.removeClass('in-cart');
	VegasCatalog.Cart.remove(id);

	return false;
});

/** PRODUCT CART ITEM */
$document.on('change-counter', '[data-product-cart-item] [data-cart="qty"]', function () {
	let $product = $(this).closest('[data-product-cart-item]');
	let pivot_id = $product.data('pivot_id');

	let cnt = $(this).find('input[type=number]').val();
	let params = {pivot_id: pivot_id, get_products_totals: true};
	VegasCatalog.Cart.changeCnt(0, cnt, params);

	return false;
});
$document.on('click', '[data-product-cart-item] [data-cart][data-action="del"]', function () {
	let $product = $(this).closest('[data-product-cart-item]');
	let id = $product.data('id');
	$product.remove();

	$(`[data-product-cart-item][data-id="${id}"]`).remove();

	VegasCatalog.Cart.remove(id, function () {
		let cnt = $('.catalog-cart--products [data-product-cart-item]').length;
		if (!cnt) {
			location.reload();
		}
	});

	return false;
});


$(document).ready(function () {
	if ($formCart.length)
		VegasCatalog.Cart.updateTotalAll();
});
